import { AddGroupDTO, GroupFormFields } from 'types';
import { pick } from 'lodash';

export const parseGroupFormFieldsIntoAddGroupDTO: (
    groupFormFields: GroupFormFields,
) => AddGroupDTO = (groupFormFields) => ({
    ...pick(groupFormFields, ['name', 'teacherIds']),
    childIds: groupFormFields.childIdsToAdd,
});
